export const getRoutePrefix = () => {
  return "";
};

export const getImageURL = (path: string | null | undefined) => {
  if (!path) return;
  if (path.includes("https")) return path;
  return path ? process.env.REACT_APP_BASE_IMAGE_URL + "/storage/" + path : "";
};

export function getAppServerName(userId: string): string {
  if (process.env?.REACT_APP_SERVER !== "HODO") {
    return `${userId?.toString()}_${process.env?.REACT_APP_SERVER?.toString()?.toLowerCase()}`;
  }
  return userId?.toString();
}
